"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuHeaderBar = MenuHeaderBar;
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const styles_1 = require("../styles");
const useStyles = (0, styles_1.createUseThemeStyles)((theme) => ({
    bar: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "0.5rem",
        width: "100%",
        padding: "0.4rem 0.75rem",
        boxSizing: "border-box",
        background: theme.palette.surface,
        borderRadius: "0.75rem",
    },
    brand: {
        "display": "flex",
        "alignItems": "center",
        "minWidth": 0,
        "marginRight": "auto",
        "& img": {
            display: "block",
            // Large enough that the pixel wordmark stays legible on small phones.
            height: "clamp(2.75rem, 9vw, 3.5rem)",
            width: "auto",
        },
    },
    account: {
        display: "flex",
        alignItems: "center",
        minWidth: 0,
    },
    settings: {
        "display": "flex",
        "alignItems": "center",
        "justifyContent": "center",
        "flex": "none",
        "width": "2rem",
        "height": "2rem",
        "padding": 0,
        "border": "none",
        "borderRadius": "0.5rem",
        "background": "transparent",
        "color": theme.palette.muted,
        "fontSize": "1.25rem",
        "cursor": "pointer",
        "transition": "color 150ms ease, background 150ms ease",
        "&:hover": {
            color: theme.palette.light.neutral,
            background: `color-mix(in oklab, ${theme.palette.light.neutral} 10%, transparent)`,
        },
    },
}));
function MenuHeaderBar({ brand, account, settingsIcon, onOpenSettings, className, }) {
    const classes = useStyles();
    return (React.createElement("header", { className: (0, classnames_1.default)(classes.bar, className) },
        React.createElement("div", { className: classes.brand }, brand),
        account && React.createElement("div", { className: classes.account }, account),
        (settingsIcon || onOpenSettings) && (React.createElement("button", { type: "button", className: classes.settings, onClick: onOpenSettings, "aria-label": "Settings" }, settingsIcon))));
}
